import Typography from "@/ui/atoms/Typography"
import { Grid } from "@/ui/structure/Grid"
import { ReactNode } from "react"

export type InfoBarItem = {
  title: ReactNode
  description: ReactNode
}

export interface InfoBarProps {
  items: InfoBarItem[]
  className?: string
}

const InfoBar = ({ items, className }: InfoBarProps) => {
  return (
    <Grid
      cols={{
        xs: 1,
        sm: 2,
        md: 4,
      }}
      gap={{
        xs: 12,
        sm: 8,
      }}
      className={className}
    >
      {items.map((item, index) => (
        <div key={index} className="text-center">
          <Typography variant={["h4", "h2"]} weight={"bold"} color={"primary"}>
            {item.title}
          </Typography>
          <Typography className="mt-2 xl:mt-6 max-w-[260px] mx-auto">
            {item.description}
          </Typography>
        </div>
      ))}
    </Grid>
  )
}

export default InfoBar
